<script>import Button from "../Button.svelte";
import SVG from "../../SVG.svelte";
export let props;
$: size = props && props.size || "default";
</script>

{#if props && props.name}
	<Button {...$$restProps} {props} on:click>
		<SVG
			name={props.name}
			size={props.size ? props.size : size}
			classNames={props.iconClassNames}
		/>
	</Button>
{/if}

